import { render, staticRenderFns } from "./MunicipioIssVigenciaForm.vue?vue&type=template&id=5120143b"
import script from "./MunicipioIssVigenciaForm.vue?vue&type=script&lang=js"
export * from "./MunicipioIssVigenciaForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports